// css
import '../css-scss/configurator.scss';

// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';

// source
import './configureConfigurator';
import './configurePartialUpdate';



// WEBPACK FOOTER //
// ./fe/web-default/src/js/index-configurator.js